import React from 'react'

import { Route } from 'react-router-dom'
import PathComponent from '@components/path-component/path-component.component'

const MatchRoute = ({ children, ...props }) => {
  return (
    <Route
      render={({ match }) => {
        const { path } = match

        return <PathComponent path={path}>{children}</PathComponent>
      }}
      {...props}
    />
  )
}

export default MatchRoute
